// Libs
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// Context
import { useComponentsPool } from '../../../ComponentsPool';
import { useModal } from '../../modal/ModalContext';
import { isNewSystem } from '../../../switch';

export default () => {
    const { Component } = useComponentsPool();
    const userWorkspaceRights = useSelector(state => state.users.currentUser.workspace_rights);
    const currentUser = useSelector(state => state.users.currentUser);
    const [t] = useTranslation();
    const modal = useModal();
    const canImportGroupsAndSkills = userWorkspaceRights.includes('CREATE:Group') && !isNewSystem()
    if (currentUser.workspace_role.workspace_role_name === 'Owner') {
        return (
            <Component
                componentName={'ActionButton'}
                canUserCreate={canImportGroupsAndSkills}
                iconButton={(<Component componentName={'Icon'} type={'settings'} />)}
                tooltipTitle={''}
                actions={[
                    {
                        icon: <Component componentName={'Icon'} type={'csvFile'} />,
                        name: t('csv:add_skills_from_csv'),
                        onClick: () => modal.update({ name: 'CSVAddSkillsPopup' })
                    },
                    {
                        icon: <Component componentName={'Icon'} type={'csvFile'} />,
                        name: t('csv:add_buildings_from_csv'),
                        onClick: () => modal.update({ name: 'CSVAddBuildingsPopup' })
                    }
                ]}
            />
        );
    }
};
